import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "../context/CartContext";

const LINKS = [
  ["Services", "#services"],
  ["Shop", "#shop"],
  ["Our Story", "#story"],
  ["Profile", "#profile"],
  ["Contact", "#contact"],
];

const PAGE_LINKS = [["Menus", "/menu"], ["Gallery", "/gallery"]];

export default function Nav() {
  const { count, setOpen } = useCart();
  const [menu, setMenu] = useState(false);

  const go = (e, hash) => {
    e.preventDefault();
    setMenu(false);
    const el = document.querySelector(hash);
    if (el) window.__lenis ? window.__lenis.scrollTo(el, { offset: -70 }) : el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header data-testid="main-nav" className="fixed top-0 w-full z-50 backdrop-blur-xl bg-[#0A0A0A]/95 border-b border-[#F9F9F6]/10">
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 md:px-10 h-[70px]">
        <a href="#top" onClick={(e) => go(e, "#top")} data-testid="nav-logo" className="flex items-center">
          <img src="/assets/logo-white.png" alt="Novaphi Catering logo" className="h-14 w-auto -my-2" />
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map(([label, hash]) => (
            <a key={hash} href={hash} onClick={(e) => go(e, hash)} data-testid={`nav-link-${label.toLowerCase().replace(" ", "-")}`}
               className="gold-underline text-xs uppercase tracking-[0.2em] text-[#F9F9F6]/70 hover:text-[#F9F9F6] transition-colors">
              {label}
            </a>
          ))}
          {PAGE_LINKS.map(([label, href]) => (
            <a key={href} href={href} data-testid={`nav-link-${label.toLowerCase()}`}
               className="gold-underline text-xs uppercase tracking-[0.2em] text-[#D4AF37] hover:text-[#F9F9F6] transition-colors">
              {label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button data-testid="cart-open-btn" onClick={() => setOpen(true)} aria-label="Open cart"
                  className="relative flex items-center gap-2 rounded-full border border-[#D4AF37]/50 px-4 py-2 text-xs uppercase tracking-[0.15em] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0A0A0A] transition-colors">
            <ShoppingBag size={15} strokeWidth={1.5} />
            <span className="hidden sm:inline">Cart</span>
            {count > 0 && (
              <span data-testid="cart-count-badge" className="absolute -top-2 -right-2 bg-[#D4AF37] text-[#0A0A0A] text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center">
                {count}
              </span>
            )}
          </button>
          <button data-testid="mobile-menu-btn" onClick={() => setMenu(!menu)} aria-label="Menu" className="md:hidden text-[#F9F9F6] p-2">
            {menu ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {menu && (
          <motion.nav initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }}
                      className="md:hidden bg-[#0A0A0A] border-b border-[#F9F9F6]/10 overflow-hidden">
            <div className="flex flex-col px-6 py-4 gap-4">
              {LINKS.map(([label, hash]) => (
                <a key={hash} href={hash} onClick={(e) => go(e, hash)} data-testid={`mobile-nav-${label.toLowerCase().replace(" ", "-")}`}
                   className="font-serif-e text-2xl text-[#F9F9F6]/80 hover:text-[#D4AF37] transition-colors">{label}</a>
              ))}
              <a href="/menu" data-testid="mobile-nav-menus"
                 className="font-serif-e text-2xl text-[#D4AF37] hover:text-[#F9F9F6] transition-colors">Menus</a>
              <a href="/gallery" data-testid="mobile-nav-gallery"
                 className="font-serif-e text-2xl text-[#D4AF37] hover:text-[#F9F9F6] transition-colors">Gallery</a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
